import { useEffect, useRef } from 'react'
import '@/styles/css/components/morph-animation.scss'

const TextMorphAnimation = () => {
	const text1Ref = useRef(null)
	const text2Ref = useRef(null)

	const texts = ['Metal Fabrication', 'Metal Recycling', 'Metal Sourcing', 'Financing Solutions']

	useEffect(() => {
		const elts = {
			text1: text1Ref.current,
			text2: text2Ref.current,
		}

		const morphTime = 1
		const cooldownTime = 2

		let textIndex = texts.length - 1
		let time = new Date()
		let morph = 0
		let cooldown = cooldownTime

		elts.text1.textContent = texts[textIndex % texts.length]
		elts.text2.textContent = texts[(textIndex + 1) % texts.length]

		function doMorph() {
			morph -= cooldown
			cooldown = 0

			let fraction = morph / morphTime

			if (fraction > 1) {
				cooldown = cooldownTime
				fraction = 1
			}

			setMorph(fraction)
		}

		function setMorph(fraction) {
			elts.text2.style.filter = `blur(${Math.min(4 / fraction - 4, 100)}px)`
			elts.text2.style.opacity = `${Math.pow(fraction, 0.2) * 100}%`

			fraction = 1 - fraction
			elts.text1.style.filter = `blur(${Math.min(4 / fraction - 4, 100)}px)`
			elts.text1.style.opacity = `${Math.pow(fraction, 0.2) * 100}%`

			elts.text1.textContent = texts[textIndex % texts.length]
			elts.text2.textContent = texts[(textIndex + 1) % texts.length]
		}

		function doCooldown() {
			morph = 0

			elts.text2.style.filter = ''
			elts.text2.style.opacity = '100%'

			elts.text1.style.filter = ''
			elts.text1.style.opacity = '0%'
		}

		function animate() {
			requestAnimationFrame(animate)

			let newTime = new Date()
			let shouldIncrementIndex = cooldown > 0
			let dt = (newTime - time) / 1000
			time = newTime

			cooldown -= dt

			if (cooldown <= 0) {
				if (shouldIncrementIndex) {
					textIndex++
				}
				doMorph()
			} else {
				doCooldown()
			}
		}

		animate()

		// Cleanup function to cancel animation frame if component unmounts
		return () => {
			cancelAnimationFrame(animate)
		}
	}, [])

	return (
		<>
			<div id='container' style={{ position: 'relative' }}>
				<h1 className='morph-banner-title'>
					India's Largest Managed <br />
					Marketplace for
					<span
						id='text1'
						ref={text1Ref}
						style={{
							position: 'absolute',
							opacity: '0%',
						}}
					></span>
					<span
						id='text2'
						ref={text2Ref}
						style={{
							position: 'absolute',
						}}
					></span>
				</h1>
			</div>
			<svg id='filters' style={{ display: 'none' }}>
				<defs>
					<filter id='threshold'>
						<feColorMatrix in='SourceGraphic' type='matrix' values='1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 255 -140' />
					</filter>
				</defs>
			</svg>
		</>
	)
}

export default TextMorphAnimation
